import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class MobileTasksService {
  constructor(private http: HttpClient) {}

  public fetchMobileTasks(params: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileTask/list`

    if (params.filters.matchAnd) {
      params.filters.matchAnd = params.filters.matchAnd.map((filter) => {
        if (filter.field === 'mobileUser.id') {
          filter.includeInCount = true
        }
        return filter
      })
    }

    return this.http.post(url, params)
  }

  public autoAssignTasks(userId?: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileTask/${
      userId ? 'autoassignTasks' : 'autoassignAllTasks'
    }${userId ? `/${userId}` : ''}`
    return this.http.get(url, {})
  }
}
